function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Landing-Page"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Promo-Landing"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M11.77,10l7.86-7.86A1.25,1.25,0,0,0,17.86.37L10,8.23,2.14.37A1.25,1.25,0,0,0,.37,2.14L8.23,10,.37,17.87a1.24,1.24,0,0,0,0,1.76,1.21,1.21,0,0,0,.88.37,1.25,1.25,0,0,0,.89-.37L10,11.77l7.86,7.86a1.25,1.25,0,0,0,.89.37,1.21,1.21,0,0,0,.88-.37,1.25,1.25,0,0,0,0-1.77Z",
    transform: "translate(0)",
    style: {
      fill: "#666"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.e474c6332d4f28391273fdf5a8a9e2e6.svg";
export { ForwardRef as ReactComponent };